<template>
  <b-form @submit="onSubmit">
    <b-form-group
      id="input-group-lastname"
      label="Nom"
      label-for="input-lastname"
    >
      <b-form-input
        id="input-lastname"
        v-model="form.staf_lastname"
        type="text"
        required
      />
    </b-form-group>

    <b-form-group
      id="input-group-firstname"
      label="Prénom"
      label-for="input-firstname"
    >
      <b-form-input
        id="input-firstname"
        v-model="form.staf_firstname"
        type="text"
        required
      />
    </b-form-group>

    <b-form-group id="input-group-email" label="E-mail" label-for="input-email">
      <b-form-input id="input-email" v-model="form.staf_email" type="email" />
    </b-form-group>

    <b-form-group
      id="input-group-gender"
      label="Genre"
      label-for="input-gender"
    >
      <b-form-select
        id="input-gender"
        v-model="form.staf_is_male"
        :options="genders"
      />
    </b-form-group>

    <b-form-group id="input-group-job" label="Rôle" label-for="input-job">
      <b-form-select id="input-job" v-model="form.job_id" :options="roles" />
    </b-form-group>

     <b-form-group id="input-group-checks-visible">
    <b-form-checkbox
      id="checkbox-is_visible"
      switch
      v-model="form.sest_is_visible"
      >Affiché dans les listes sur tablette</b-form-checkbox
    >
     </b-form-group>
    <b-form-checkbox
      id="checkbox-is_enable"
      switch
      v-model="form.sest_is_enable"
      >Actif</b-form-checkbox
    >
    <b-form-checkbox
      id="checkbox-is_delete"
      switch
      v-model="form.sest_is_delete"
      >Supprimé</b-form-checkbox
    >

    <p class="float-right">
      <b-button type="close" @click="onCancel">Annuler</b-button>
      <b-button type="submit" variant="primary">Valider</b-button>
    </p>
  </b-form>
</template>

<script>
import { getStaff } from "../../services/staffs";
import { JobsList } from "../../services/global";

export default {
  name: "FormStaff",
  props: {
    esta: {
      type: Number,
      default: null,
    },
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      form: {
        esta_id: null,
        staf_id: "",
        staf_lastname: "",
        staf_firstname: "",
        staf_email: "",
        staf_is_male: true,
        sest_is_enable: true,
        sest_is_delete: false,
        sest_is_visible: true,
        job_id: 1,
      },
      genders: [
        { text: "Homme", value: true },
        { text: "Femme", value: false },
      ],
      roles: [],
    };
  },
  async created() {
    const r =  await JobsList();
    if(r) this.roles = r ;
    
    const data = await getStaff(this.esta, this.id);
    if (data) {
      this.form = data;
      this.form.job_id = data.job && data.job.id ? data.job.id : 1;
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$emit("sendForm", JSON.stringify(this.form));
    },
    onCancel(evt) {
      evt.preventDefault();
      this.$emit("sendCancel");
    },
  },
};
</script>

<style scoped>
</style>
